// Resume content data for Trent Roddan
import trentPhoto from "../assets/trent.webp";
import thumb1 from "../assets/videos/OqfvRPMl6ok.jpg";
import thumb2 from "../assets/videos/qpKyQ5jcFtk.jpg";
import thumb3 from "../assets/videos/_anSRRQYCQg.jpg";
import thumb4 from "../assets/videos/7ZqZfJgafhc.jpg";
import thumb5 from "../assets/videos/-zVITWRULts.jpg";
import thumb6 from "../assets/videos/u9CkWW876nA.jpg";
import thumb7 from "../assets/videos/Z83t1iejpc8.jpg";
import thumb8 from "../assets/videos/vDB50V0eKbU.jpg";
import thumb9 from "../assets/videos/w9WJM0usDuo.jpg";

export const resumeData = {
  name: { top: "RÉSUMÉ", full: "TRENT RODDAN" },
  title: "Commercial Executive · Business Owner · Technology Leader",
  initials: "TR",
  photo: trentPhoto,
  contact: {
    location: "Sydney & Hunter Region, NSW",
    mobile: "0410 677 727",
    mobileHref: "tel:+61410677727",
    email: "trent.roddan@gmail.com",
    emailHref: "mailto:trent.roddan@gmail.com",
    web: "Image Traders · Iceberg CMS",
    linkedin: "linkedin.com/in/trent-roddan",
    linkedinHref: "https://www.linkedin.com/in/trent-roddan-b193385/",
  },

  profile: [
    "Commercially focused business owner and executive with more than 26 years' experience building and managing businesses, developing long-term client relationships, leading marketing and technology programs, coordinating specialist teams and identifying practical opportunities for growth.",
    "Founder and Managing Director of Image Traders and Iceberg CMS; Owner/Director of Athlete Tracker and Air Log; and Director and Company Secretary of CoaX Helicopters. Experience working directly with owners and management teams across aviation, transport, electrical services, insurance, sport and professional services, combining commercial judgement, marketing and business-development capability, technology leadership, and trade and operational experience.",
    "Brings more than 27 years of direct involvement with RNAC, having become a member in 1999 — as a member, student pilot, service provider and former hangar tenant — together with broader aviation experience spanning flying-school startup support, helicopter operations, aviation marketing, business systems and emerging aviation technology. Particularly suited to an executive model in which the CEO provides strategic, commercial, financial and organisational leadership while specialist finance and flying-operations functions provide technical expertise.",
  ],

  ceoAlignment: {
    subtitle: "RNAC / Maitland Airport",
    items: [
      {
        head: "Commercial Leadership & Business Development",
        body: "26+ years establishing, operating and developing businesses, identifying revenue opportunities and building enduring commercial relationships.",
      },
      {
        head: "Marketing & Growth",
        body: "Extensive strategic and hands-on experience in customer acquisition, retention, membership-style engagement, digital marketing, brand, content, CRM, SEO, paid media and performance measurement.",
      },
      {
        head: "Aviation & RNAC Knowledge",
        body: "RNAC member for more than 27 years, having joined in 1999; former Maitland Airport hangar tenant; current student pilot; aviation client, technology and operational experience.",
      },
      {
        head: "Technology & Transformation",
        body: "Founder of a software and managed-IT company with experience in custom business systems, APIs, cloud infrastructure, cybersecurity awareness, disaster recovery, automation and AI.",
      },
      {
        head: "Leadership & Stakeholder Engagement",
        body: "Experience leading staff, contractors, specialist suppliers, clients, athletes and community stakeholders, with a strong training, coaching and collaborative-management background.",
      },
      {
        head: "Financial & Commercial Accountability",
        body: "Long-term responsibility for the financial sustainability of privately owned businesses, including pricing, expenditure, budget allocation and commercial decision-making; comfortable working with professional accounting and finance specialists for formal reporting, forecasting and governance.",
      },
      {
        head: "Practical Infrastructure Perspective",
        body: "Trade-qualified electrical fitter mechanic with construction, installation, maintenance, fault-finding, breakdown and regional maintenance-management experience.",
      },
    ],
  },

  experience: [
    {
      company: "Image Traders Pty Ltd",
      meta: "Digital Marketing & Business Growth",
      role: "Founder & Managing Director",
      period: "June 2000 – Present",
      link: {
        label: "View client case studies → imagetraders.com.au/case-studies/",
        href: "https://www.imagetraders.com.au/case-studies/",
      },
      points: [
        "Founded and lead a specialist agency providing fractional marketing leadership to owner-led and mid-sized organisations (turnover ~$15–20M).",
        "Partner with owners and senior management to align marketing, acquisition, brand and business development with revenue objectives.",
        "Build and run annual multi-channel programs — websites, CRM, email, social, SEO, paid media, content, e-commerce and lead generation.",
        "Use performance and lead data to guide strategy and budget, and coordinate designers, developers, media and other specialist contractors.",
        "Built lasting client relationships - including The GBE Group, a Newcastle based electrical contracting firm (and one of Image Traders first clients) for over 26 years.",
        "Delivered marketing and content for aviation clients including Heli Aust, Helitreck, Rotordyne, Aerodyne and Heli Dynamic.",
      ],
    },
    {
      company: "Iceberg Content Management Systems Pty Ltd",
      meta: "Software Development & Managed IT",
      role: "Founder & Managing Director",
      period: "2006 – Present",
      points: [
        "Founded and lead a software/IT business delivering custom cloud platforms, systems integration and ongoing support.",
        "Directed development of business, insurance, sports-club, aviation and complex scheduling systems from operational requirements.",
        "Provide managed IT — servers, email, user support, backups, disaster recovery and business continuity.",
        "Lead research into secure AI-enabled systems, data privacy and information governance.",
      ],
    },
    {
      company: "Athlete Tracker Pty Ltd",
      meta: "Sports Club & Athlete Management Software",
      role: "Founder & Managing Director",
      period: "2016 – Present",
      points: [
        "Own and direct a sports club-management software business supporting administration, participation and athlete development.",
        "Developed products used in AFL academies, combining participant records, program admin, KPI-based development, and video analysis software.",
        "This work later shaped the aviation training and management features within Air Log.",
      ],
    },
    {
      company: "Air Log Pty Ltd",
      meta: "Custom Aviation Business Management Platform",
      role: "Founder & Managing Director",
      period: "2022 – Present",
      points: [
        "Founded Air Log to commercialise a custom aviation business-management platform, first built for Multi Access Drone Solutions.",
        "Covers communications, asset/equipment management, operational workflows, administration and aviation record-keeping.",
        "Includes syllabus and training systems for remote pilot, helicopter and fixed-wing courses with progress and KPI tracking (under development).",
        "Integrates websites, apps and other systems via APIs and automation, with ongoing AI-assisted development.",
      ],
    },
    {
      company: "CoaX Helicopters Pty Ltd",
      meta: "Aviation Technology",
      role: "Director & Company Secretary",
      period: "2007 – Present",
      points: [
        "Director and Company Secretary of a former public company, developing autonomous heavy-lift coaxial-rotor drones.",
        "Provides direct governance, corporate administration and aviation-technology experience alongside commercial leadership.",
      ],
    },
  ],

  aviation: [
    "Royal Newcastle Aero Club / Maitland Airport — full member for more than 27 years, having joined in 1999; former Maitland Airport hangar tenant and current student pilot; previously supplied and managed the Club website for approximately a decade.",
    "Heli Dynamic — assisted in establishing a Sunshine Coast helicopter flying school, including brand, website, marketing and advertising.",
    "Heli Aust / Helitreck / Heli Dynamic — worked as an assistant / crewman during external-load and lifting operations while also producing photography, video and marketing content (see examples in the Featured Videos section).",
    "Multi Access Drone Solutions — supported startup of an agricultural drone operator with branding, website, digital marketing and business-development support.",
  ],

  earlyCareer: {
    company: "DEVE Hydraulic Lifts",
    period: "1991 – c. 2001",
    role: "Electrical Apprentice · Fitter Mechanic · Store & Parts Manager · Regional Maintenance Manager",
    points: [
      "Commenced an electrical apprenticeship after completing the HSC in 1991, working in lift construction and installation before moving into maintenance and emergency breakdown response.",
      "Completed an Electrical Trade Certificate through TAFE and worked as an Electrical Fitter Mechanic (specialising in hydraulics) installing, servicing, fault-finding and repairing hydraulic lift systems.",
      "Progressed into Store and Parts Manager and later Regional Maintenance Manager, travelling throughout Australia to assist and train electrical contractors maintaining DEVE equipment outside Sydney.",
      "Developed practical experience in safety-conscious operations, technical problem-solving, contractor management, parts and service coordination, training and customer relationships.",
    ],
  },

  leadership: [
    "Founder, owner and director across multiple current businesses, with responsibility for strategic direction, commercial decisions, corporate administration, client relationships, product development, project delivery and coordination of staff and specialist contractors.",
    "Pennant Hills Australian Football Club — more than 15 years across committee, playing, coaching, technology and marketing roles.",
    "Coached AFL academy and state-development athletes using performance management, education and KPI-based methods; approximately 10 athletes progressed to the highest AFL level.",
    "Experienced in communicating with business owners, management teams, technical specialists, contractors, community organisations and aviation stakeholders.",
  ],

  capabilities: [
    { area: "Commercial & Strategic", detail: "Business development · commercial opportunity identification · strategic planning · contract/client relationships · revenue focus · project leadership" },
    { area: "Marketing & Growth", detail: "Marketing strategy · customer acquisition & retention · CRM · digital · content · SEO · paid media · brand · analytics · KPI reporting" },
    { area: "Technology & Systems", detail: "Business systems · WordPress · Shopify · APIs · cloud applications · IT management · backup/DR · cybersecurity awareness · AI integration" },
    { area: "Leadership & Delivery", detail: "People & contractor leadership · stakeholder engagement · training · coaching · project management · operational problem-solving" },
    { area: "Aviation", detail: "RNAC/Maitland Airport knowledge · flying-school support · helicopter operations · aviation technology · aviation marketing & systems" },
  ],

  skills: [
    { name: "Commercial & Business Development", level: 10 },
    { name: "Marketing & Digital Growth", level: 10 },
    { name: "Technology & Software Systems", level: 9 },
    { name: "Leadership & Stakeholder Management", level: 9 },
    { name: "Aviation Industry Knowledge", level: 8 },
    { name: "Financial & Commercial Accountability", level: 8 },
  ],

  education: [
    { title: "Higher School Certificate (HSC)", meta: "1991" },
    { title: "Electrical Trade Certificate", meta: "TAFE — completed through DEVE Hydraulic Lifts apprenticeship" },
    { title: "Certificate IV in Small Business Management", meta: "Completed while establishing Image Traders" },
    { title: "University of Newcastle", meta: "Commenced mature-age double-degree in Fine Art & Education; completed first year before studies were discontinued due to family circumstances and focus on building Image Traders" },
    { title: "Ongoing Professional Development", meta: "Digital marketing, business systems, e-commerce, CRM, software development, IT, APIs, cybersecurity awareness, analytics & artificial intelligence" },
  ],

  additional: [
    "Shares time between Sydney and the Hunter Region and is available for on-site work.",
    "Professional referees available on request.",
  ],

  simulators: {
    heading: "Currently building 3 flight simulators:",
    items: [
      "Cessna 172 with G1000 cockpit (real cabin)",
      "Piper PA-28-140 Cherokee with G5s, GTN 650 & 750 (real cabin)",
      "Robinson R44 with VR goggles",
    ],
  },

  aviationClients: [
    "McIvers Helicopters",
    "Weiland Helicopters",
    "Wieland Aviation",
    "Wieland Helicopter Technology",
    "CoaX Helicopters",
    "Heli Aust",
    "Heli Muster",
    "Aero Support",
    "Helitreck",
    "Heli Aust Australia",
    "Heli Dynamic",
    "Aerodyne",
    "Rotordyne (Aircraft Maintenance and Avionics)",
    "Rotordyne Helicopters",
    "Multi Access Drone Solutions",
  ],

  videos: [
    { id: "OqfvRPMl6ok", title: "Featured Video 1", thumb: thumb1 },
    { id: "qpKyQ5jcFtk", title: "Featured Video 2", thumb: thumb2 },
    { id: "_anSRRQYCQg", title: "Featured Video 3", thumb: thumb3 },
    { id: "7ZqZfJgafhc", title: "Featured Video 4", thumb: thumb4 },
    { id: "-zVITWRULts", title: "Featured Video 5", thumb: thumb5 },
    { id: "u9CkWW876nA", title: "Featured Video 6", thumb: thumb6 },
    { id: "Z83t1iejpc8", title: "Featured Video 7", thumb: thumb7 },
    { id: "vDB50V0eKbU", title: "Featured Video 8", thumb: thumb8 },
    { id: "w9WJM0usDuo", title: "Featured Video 9", thumb: thumb9 },
  ],
};
